import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const container = document.querySelector(".custom-scroll");
        if (container) {
            container.scrollTo({ top: 0, left: 0, behavior: "auto" }); // or "smooth"
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return null;
};

export default ScrollTop;
